import { APCGPaymentResponse, APCGRegistrationResponse, VerifyPaymentResponse, WorkshopCountResponse, APCGSupportTicketInsert, SupportTicketResponse, CategoryCountResponse, APCGZeroAmountRegistrationResponse } from "../types/payments";
import apiClient from  "./apiClient";


/**
 * Initiates a payment and returns the PayFort redirection URL.
 */

export const initiatePayment = async (
  paymentData: FormData
): Promise<APCGPaymentResponse> => {
  const response = await apiClient.post<APCGPaymentResponse>(
    "/payment/APCGPayment",
    paymentData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

/**
 * Verifies the payment response received from PayFort.
 */
export const verifyPayment2 = async (
  paymentParams: Record<string, string>
): Promise<VerifyPaymentResponse> => {
  const response = await apiClient.post<VerifyPaymentResponse>(
    "/payment/APCGPaymentVerify",
    paymentParams
  );
  return response.data;
};

export const verifyPayment = async (
  paymentParams: Record<string, string>
): Promise<VerifyPaymentResponse> => {
  try {
    const response = await apiClient.post<VerifyPaymentResponse>(
      "/payment/APCGPaymentVerify",
      paymentParams
    );
    return response.data;
  } catch (error) {
    console.error("🔴 Payment Verification Error:", error instanceof Error ? error.message : "Unknown error");
    throw error;
  }
};

export const getRegistrationDetails = async (
  apcgId: string
): Promise<APCGRegistrationResponse> => {
  const response = await apiClient.post<APCGRegistrationResponse>(
    `/payment/APCGRegistration?apcgId=${apcgId}`
  );
  return response.data;
};

/**
 * Gets the current workshop participant counts
 */
export const getWorkshopCounts = async (): Promise<WorkshopCountResponse> => {
  try {
    const response = await apiClient.get<WorkshopCountResponse>(
      "/Payment/GetWorkShopsCount"
    );
    
    // Return the new API structure
    return response.data;
  } catch (error) {
    console.error("Failed to fetch workshop counts:", error);
    // Return default counts if API fails
    return {
      morningSessionCount: 0,
      afternoonSessionCount: 0,
      fulldaySessionCount: 0,
      morningWorkshops: {},
      afternoonWorkshops: {},
      fulldayWorkshops: {}
    };
  }
};

/**
 * Gets member details by APCG ID
 */
export const getMembersByAPCGId = async (apcgId: string): Promise<any[]> => {
  try {
    const response = await apiClient.get<any[]>(
      `/Payment/GetMembersByAPCGId/${apcgId}`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch member details:", error);
    throw error;
  }
};

/**
 * Creates a support ticket
 */
export const createSupportTicket = async (
  supportTicketData: APCGSupportTicketInsert
): Promise<SupportTicketResponse> => {
  try {
    const response = await apiClient.post<SupportTicketResponse>(
      "/payment/CreateSupportTicket",
      supportTicketData
    );
    return response.data;
  } catch (error) {
    console.error("Support ticket creation failed", error);
    throw error;
  }
};

/**
 * Gets the current count for a specific category
 */
export const getCategoryCount = async (categoryName: string): Promise<CategoryCountResponse> => {
  try {
    const response = await apiClient.get<CategoryCountResponse>(
      `/Payment/GetCategoryCount?category=${encodeURIComponent(categoryName)}`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch category count:", error);
    throw error;
  }
};

/**
 * Registers for zero amount (free) category
 */
export const registerZeroAmount = async (
  registrationData: FormData
): Promise<APCGZeroAmountRegistrationResponse> => {
  try {
    const response = await apiClient.post<APCGZeroAmountRegistrationResponse>(
      "/Payment/APCGZeroAmountRegistration",
      registrationData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Zero amount registration failed", error);
    throw error;
  }
};